<select-item id="select"
             [selectedId]="config?.viewId"
             [items]="viewSelectItems"
             [removable]="false"
             [disabled]="!editable"
             i18n-emptyValue="@@search.tabs.settings.dialog.config.view.placeholder"
             emptyValue="Select View"
             (selected)="onViewSelected($event)">
</select-item>
